export default __webpack_public_path__ + "3e3e3d5e2cd5d6201a54f29dc449e531.png";